export enum SalesDepositDiscountType {
  CustomPercentage = 'custom-percentage',
  CustomAmount = 'custom-amount',
}
